import { CustomerNotificationLocation } from '@shared-ui/customer-notifications';
import { SortAndFiltersViewType } from 'src/common/__generated__/api';
export const listViewPillsExperimentTemplate = {
  id: 'list-view-filter-pills-large',
  version: '1',
  components: [{
    metadata: {
      id: 'ListViewLayout'
    },
    type: 'ListViewLayout',
    config: {
      reverse: true // render the fixed-width side-rail region first to reduce cls //
    },

    children: [{
      metadata: {
        id: 'LayoutFlexItemSiderail'
      },
      type: 'EGDSComponent',
      config: {
        type: 'EGDSLayoutFlexItem'
      },
      children: [{
        metadata: {
          id: 'sideRailRegion'
        },
        type: 'SideRailRegion',
        children: [{
          metadata: {
            id: 'mesoSideRail'
          },
          type: 'MesoSideRail'
        }]
      }]
    }, {
      metadata: {
        id: 'LayoutFlexItemMain'
      },
      type: 'EGDSComponent',
      config: {
        type: 'EGDSLayoutFlexItem',
        grow: 1
      },
      children: [{
        metadata: {
          id: 'toolbarRegion'
        },
        type: 'ToolbarRegion',
        children: [{
          metadata: {
            id: 'playback'
          },
          type: 'Playback'
        }]
      }, {
        metadata: {
          id: 'resultsWrapper'
        },
        type: 'ResultsWrapper',
        config: {
          columns: 1,
          space: 'six',
          bexQuickFiltersEnabled: true
        },
        children: [{
          metadata: {
            id: 'filterbarColumn'
          },
          type: 'EGDSComponent',
          config: {
            type: 'EGDSLayoutGridItem',
            colSpan: 1
          },
          children: [{
            metadata: {
              id: 'filterbar'
            },
            type: 'Filterbar',
            config: {
              view: SortAndFiltersViewType.FILTER_BAR,
              bexQuickFiltersEnabled: true
            }
          }]
        }]
      }, {
        metadata: {
          id: 'mainRegion'
        },
        type: 'MainRegion',
        children: [{
          metadata: {
            id: 'mitHeader'
          },
          type: 'MitHeader'
        }, {
          metadata: {
            id: 'customerNotificationsAfterHeader'
          },
          type: 'CustomerNotificationTemplateComponent',
          config: {
            location: CustomerNotificationLocation.AFTER_HEADER
          }
        }, {
          metadata: {
            id: 'resultsWrapper'
          },
          type: 'ResultsWrapper',
          config: {
            columns: 4,
            space: 'six'
          },
          children: [{
            metadata: {
              id: 'resultsColumn'
            },
            type: 'EGDSComponent',
            config: {
              type: 'EGDSLayoutGridItem',
              colSpan: 3
            },
            children: [{
              metadata: {
                id: 'results-header'
              },
              type: 'ResultsHeader'
            }, {
              metadata: {
                id: 'search-results'
              },
              type: 'SearchResultsWrapper'
            }]
          }, {
            metadata: {
              id: 'sidebarColumn'
            },
            type: 'EGDSComponent',
            config: {
              type: 'EGDSLayoutGridItem',
              colSpan: 1
            },
            children: [{
              metadata: {
                id: 'sidebar'
              },
              config: {
                bexQuickFiltersEnabled: true
              },
              type: 'Sidebar'
            }]
          }]
        }, {
          metadata: {
            id: 'customerNotificationsFooter'
          },
          type: 'CustomerNotificationTemplateComponent',
          config: {
            location: CustomerNotificationLocation.FOOTER
          }
        }]
      }]
    }]
  }]
};